import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '..';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';
import { JSONP_ERR_WRONG_RESPONSE_TYPE } from '@angular/common/http/src/jsonp';

@Injectable({ providedIn: 'root' })
export class DealerLeadEnquiriesService extends BaseService {

    constructor(protected http: HttpClient, protected authenticationService: AuthenticationService) {
        super(http, authenticationService, 'dealerLeadEnquiries');
    }
    public getExport() {
        const httpOptions = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<any>(`${environment.apiUrl}` + '/admin/' + this.type + '/export',httpOptions);
        // return this.http.get<any>('/down',httpOptions);
    }
}
